import React from "react";
import { connect } from "react-redux";
import { PAGING_TYPE } from "../constants";
import { getVisibleParticipantCount, getFilmStyle } from "../functions";

import RemoteFilm from "./RemoteFilm";
import LayoutPaging from "./LayoutPaging";

function GridMode({ width, height }) {
    return (
        <>
            <LayoutPaging type={PAGING_TYPE.PREV} isVertical={false} />
            <div style={{ display: "inline-flex", flex: "1", flexWrap: "wrap", justifyContent: "center", maxHeight: "100%" }}>
                <RemoteFilm style={{ width: `${width}px`, height: `${height}px` }} />
            </div>
            <LayoutPaging type={PAGING_TYPE.NEXT} isVertical={false} />
        </>
    );
}

function _mapStateToProps(state) {
    const visibleParticipantCount = getVisibleParticipantCount(state);
    const { width, height } = getFilmStyle(state, visibleParticipantCount, false);

    return {
        visibleParticipantCount,
        width, height
    }
}

export default connect(_mapStateToProps)(GridMode);